module.exports = __webpack_public_path__ + "static/img/GARRISON-KENH.21ff98e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GARRISON-KENH.jpg
// module id = j/DX
// module chunks = 0